import { App } from "./3D/app";
import "animate.css";
import "./assets/css/output.css";
import gsap from "gsap";
import { isDevice } from "./utils/isDevice";
import { angelopolisApi } from "./api/angelopolisAPi";
import menumovile from "./PageComponents/menuLotes.html";
import losdinfScreen from "./PageComponents/loadingScreen.html";
import modalPdfAsesor from "./PageComponents/modalCotizadorPdf.html";
import packageInfo from "/package.json";

const menuLotesContainer = document.getElementById("menuLotesContainer");
menuLotesContainer.innerHTML += menumovile;

const containerModalPDFAsesor = document.getElementById(
  "containerModalPDFAsesor"
);
containerModalPDFAsesor.innerHTML += modalPdfAsesor;
const loadingScreenComponent = document.getElementById(
  "loadingScreenComponent"
);

loadingScreenComponent.innerHTML += losdinfScreen;
document.getElementById("versioner").innerText = packageInfo.version;
console.log(packageInfo.version);
// const labelScreen = document.getElementById("screen-sized");
// const screenH = window.innerHeight;
// const screenW = window.innerWidth;
// labelScreen.innerText = `h: ${screenH} - W: ${screenW} `;
if (!isDevice()) {
  document
    .getElementById("switch-option")
    .classList.replace("slider", "slider-desktop");
}

const angelApi = new angelopolisApi();
angelApi.onGetApiData(() => {
  const container = document.getElementById("container");
  const app = new App(container);
  window.addEventListener("resize", () => {
    app.onResized();
  });
});

let b1 = "";
let timed = gsap.timeline({ repeat: -1, yoyo: true });
timed.set("#container", { background: b1, duration: 7 });
timed.set("#loading", { background: b1, duration: 7 });
